<template>
  <div class="header-subject">
    <el-card
      class="box-card"
      :body-style="{ padding: '0px' }"
      v-for="(item,index) in tableData"
      :key="index"
      shadow="never"
    >
      <el-image
        class="box-card-img"
        :src="imgUrl+item.pic_path"
        :preview-src-list="previewList"
        @click="$emit('previewImg',item.pic_path)"
      />
      <div class="box-card-body">
        <span class="box-card-body-name">{{item.name}}</span>
        <div class="box-card-button">
          <el-button type="text" @click="$emit('modifySubject',item,index)">修改</el-button>
          <el-button
            type="text"
            class="box-card-button-delete"
            @click="$emit('deleteSub',item)"
          >删除</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: ["tableData", "previewList"]
};
</script>

<style scoped src="../style/index.css"></style>